

export const routes_api =  {
    "qrcode": {
      "generate": "/qr-code/base64/",
    },
    "translations": {
        "get": "/data/init_tv",
    },
    "screen": {
      "init": "/screen/init/",
      "init_preview": "/screen/init/flow_preview/",
      "init_flow": "/screen/init/:token/flow/:flow_id",
      "init_area": "/screen/init/:token/flow/:flow_id/area/:area_slug",
      "screenshot": "/screen/:id/previewShot",
      "ping_screen": "/screen/log/:screen_token/:screen_id",
      "mercure_log": "/screen/log_mercure/:screen_token/:screen_id",
    }
}
